import { type FC, Fragment } from "react";
import { type SkillCassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import * as styles from "../styles.css";

export const SkillCassette: FC<SkillCassetteProps> = ({ skills }) => (
  <dl className={styles.skillList}>
    {skills.map((categorizedSkills) => (
      <Fragment key={categorizedSkills.name}>
        <dt>{categorizedSkills.name}</dt>
        <dd>
          <ul className={styles.categorizedSkillList}>
            {categorizedSkills.skills.map((skill) => (
              <li key={skill.name}>
                <span className={styles.tagLabel}>{skill.name}</span>
              </li>
            ))}
          </ul>
        </dd>
      </Fragment>
    ))}
  </dl>
);
